import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { EditIcon } from "../../../ui/icons/edit";
import { TrashIcon } from "../../../ui/icons/trash";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { PopupForm } from "../../../ui/organisms/popupForm";
import { activityOptions, formatterDate, optionsFormatter } from "../../../utils";
import { GetByIdPersonalManagement, resetGetByIdPersonalManagementResourcesStatus } from "../slice";
import { ValutazioniPopupAdd } from "./boxPopupOptions/add";
import { ValutazioniPopupEdit } from "./boxPopupOptions/edit";
import { EvaluationDTO } from "./dataService/dto";
import { DeleteEvaluation, GetEvaluationById, addEvaluations, resetEvaluationCreationRequest, resetEvaluationDeleteStatus, resetEvaluationError, resetEvaluationUpdateRequest, resetEvaluations, resetGetEvaluationByIdStatus, setEvalIdToUpdate, setPMId, setUpdateEvaluationActivityId, setUpdateEvaluationDate, setUpdateEvaluatorId, setUpdateNote, setUpdateResult } from "./slice";

export function BoxValutazioni() {
    const dispatch = useAppDispatch();
    const PMState = useAppSelector(state => state.personalManagement);
    const evaluationsState = useAppSelector(state => state.PMEvaluations);
    const [openPopup, setOpenPopup] = useState<boolean>(false);
    const [openEditPopup, setOpenEditPopup] = useState<boolean>(false);

    const onEditHandler = (ev: EvaluationDTO) => {
        dispatch(setUpdateEvaluationDate(ev.evaluationDate));
        dispatch(setUpdateEvaluationActivityId(ev.evaluationActivityId));
        dispatch(setUpdateEvaluatorId(ev.evaluatorId));
        dispatch(setUpdateResult(ev.result));
        dispatch(setUpdateNote(ev.note));
        dispatch(setEvalIdToUpdate(ev.id!));
        setOpenEditPopup(true);
    };

    useEffect(() => {
        if (PMState.currentPersonalManagementId) {
            dispatch(setPMId(PMState.currentPersonalManagementId));
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!));
        }
    }, [PMState.currentPersonalManagementId]);

    useEffect(() => {
        dispatch(resetEvaluations());
        if (
            PMState.getByIdPersonalManagementResourcesStatus === 'successfully' &&
            PMState.getByIdPersonalManagementResourcesResponse?.evaluationIds
        ) {
            dispatch(resetGetByIdPersonalManagementResourcesStatus('idle'));
            for (let index = 0; index < PMState.getByIdPersonalManagementResourcesResponse.evaluationIds.length; index++) {
                dispatch(GetEvaluationById(PMState.getByIdPersonalManagementResourcesResponse.evaluationIds[index].toString()));
            }
        }
    }, [PMState.getByIdPersonalManagementResourcesStatus]);

    useEffect(() => {
        if (
            evaluationsState.getEvaluationByIdStatus === 'successfully' &&
            evaluationsState.getEvaluationByIdResponse !== undefined
        ) {
            dispatch(resetGetEvaluationByIdStatus());
            dispatch(addEvaluations(evaluationsState.getEvaluationByIdResponse));
        }
    }, [evaluationsState.getEvaluationByIdStatus]);

    useEffect(() => {
        if (evaluationsState.evaluationDeleteStatus === 'successfully') {
            dispatch(resetEvaluationDeleteStatus());
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!));
        }
    }, [evaluationsState.evaluationDeleteStatus]);

    return (
        <div className="p-6">
            <div className="space-y-3">
                <div className="flex items-center justify-between">
                    <span className="font-bold text-2xl text-neutral-850">Valutazioni</span>
                    <ButtonComponent
                        size="md"
                        iconPosition="off"
                        variant="solid"
                        color="orange"
                        label="Aggiungi valutazione"
                        onClick={() => setOpenPopup(true)}
                    />
                </div>

                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                    <table className="w-full border-collapse text-text-md min-w-[900px]">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Data</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Funzione Valutata</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Valutatore</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Esito</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Note</th>
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[72px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {evaluationsState.evaluations.length === 0 ? (
                                <tr>
                                    <td colSpan={6} className="px-3 py-3 text-left text-neutral-500 bg-white">
                                        Nessuna valutazione trovata
                                    </td>
                                </tr>
                            ) : (
                                evaluationsState.evaluations.map((ev, index) => (
                                    <tr
                                        key={ev.id}
                                        className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {formatterDate(ev.evaluationDate)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {optionsFormatter(ev.evaluationActivityId, activityOptions)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {ev.evaluatorId}
                                        </td>
                                        <td className="px-3 py-2">
                                            <span className={ev.result === 'POSITIVO' ? 'result positive' : 'result negative'}>
                                                {ev.result}
                                            </span>
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700">
                                            {ev.note}
                                        </td>
                                        <td className="px-3 py-2 w-[72px]">
                                            <div className="flex items-center justify-center gap-2">
                                                <button
                                                    className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => onEditHandler(ev)}
                                                >
                                                    <EditIcon color={"Orange"} size={18} />
                                                </button>
                                                <button
                                                    className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => dispatch(DeleteEvaluation(ev.id!))}
                                                >
                                                    <TrashIcon color={"Orange"} size={18} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {openPopup && (
                <PopupForm title="Aggiungi Valutazione" close={() => {
                    dispatch(resetEvaluationError());
                    dispatch(resetEvaluationCreationRequest());
                    setOpenPopup(false);
                }}>
                    <ValutazioniPopupAdd close={() => setOpenPopup(false)} />
                </PopupForm>
            )}

            {openEditPopup && (
                <PopupForm title="Modifica Valutazione" close={() => {
                    dispatch(resetEvaluationError());
                    dispatch(resetEvaluationUpdateRequest());
                    setOpenEditPopup(false);
                }}>
                    <ValutazioniPopupEdit close={() => setOpenEditPopup(false)} />
                </PopupForm>
            )}
        </div>
    );
}